import { useStore } from "@state/store"
import styled from "styled-components/macro"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"
import InfoCarouselVariant3 from "@common/features/Info2/components/InfoCarouselVariant3"

const InfoLayout = ({ className, info1Data }) => {
  const contentControls = useStore((s) => s.contentControls)

  return (
    <Wrapper className={className}>
      <InfoCarouselVariant3 info1Data={info1Data} />
    </Wrapper>
  )
}

export default InfoLayout

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #ede9e3;
`
